import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { mediaUrl } from "@/lib/media";
import type { Product } from "@/lib/types";
import { QuantityStepper } from "@/components/QuantityStepper";

type ProductCardProps =
  | { mode: "display"; product: Product }
  | { mode: "order"; product: Product; quantity: number; onQuantityChange: (quantity: number) => void };

export function ProductCard(props: ProductCardProps) {
  const { product } = props;
  const primary = product.images.find((img) => img.is_primary) ?? product.images[0];
  const imageUrl = mediaUrl(primary?.image);

  return (
    <Card className="overflow-hidden py-0 gap-0">
      <div className="aspect-square w-full overflow-hidden bg-muted">
        {imageUrl ? (
          // eslint-disable-next-line @next/next/no-img-element
          <img src={imageUrl} alt={product.name} className="size-full object-cover" />
        ) : (
          <div className="flex size-full items-center justify-center text-4xl">🍪</div>
        )}
      </div>
      <CardHeader className="gap-1 pt-4">
        <div className="flex items-start justify-between gap-2">
          <h3 className="font-heading text-lg leading-tight font-semibold">{product.name}</h3>
          <span className="shrink-0 font-semibold text-primary">${product.price}</span>
        </div>
      </CardHeader>
      <CardContent className="flex flex-1 flex-col justify-between gap-4 pb-4">
        {product.description && (
          <p className="text-sm text-muted-foreground">{product.description}</p>
        )}
        {props.mode === "order" && (
          <div className="flex justify-end">
            <QuantityStepper value={props.quantity} onChange={props.onQuantityChange} />
          </div>
        )}
      </CardContent>
    </Card>
  );
}
